import { defineStore } from 'pinia';

import * as state from './estate.state';
import * as getters from './estate.getters';
import * as actions from './estate.actions';

export const useEstateStore = defineStore('estate', () => ({
  ...state,
  ...getters,
  ...actions
}));
